module.exports = __webpack_public_path__ + "img/te.34f1f5dc.svg";